"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_jss_1 = require("react-jss");
var theme_1 = require("../../../../mantine-theme/src");
exports.default = react_jss_1.createUseStyles({
    tab: function (_a) {
        var theme = _a.theme, reduceMotion = _a.reduceMotion;
        return (__assign(__assign(__assign({}, theme_1.getFontStyles(theme)), theme_1.getFocusStyles(theme)), { WebkitTapHighlightColor: 'transparent', boxSizing: 'border-box', display: 'block', height: 40, backgroundColor: 'transparent', border: 0, borderBottom: '2px solid transparent', padding: [0, theme.spacing.md], fontSize: theme.fontSizes.sm, cursor: 'pointer', transition: reduceMotion ? 'none' : 'border-color 150ms ease, color 150ms ease', color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.black, '&:disabled': {
                cursor: 'not-allowed',
                color: theme.colorScheme === 'dark' ? theme.colors.dark[3] : theme.colors.gray[5],
            } }));
    },
    tabActive: function (_a) {
        var theme = _a.theme, color = _a.color;
        return ({
            color: theme_1.getThemeColor({ theme: theme, color: color, shade: theme.colorScheme === 'dark' ? 4 : 6 }),
            borderBottomColor: theme_1.getThemeColor({ theme: theme, color: color, shade: theme.colorScheme === 'dark' ? 4 : 6 }),
        });
    },
    tabInner: {
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        lineHeight: 1,
        height: 40,
    },
    tabIcon: function (_a) {
        var theme = _a.theme;
        return ({
            '&:not(:only-child)': {
                marginRight: theme.spacing.xs,
            },
            // this fixes alignment as by default images and svg are inline and will have extra space on the bottom
            '& *': {
                display: 'block',
            },
        });
    },
});
